import axios from 'axios';
import { history } from '../components/History/History';

const instance = axios.create({
    // baseURL: 'http://192.168.68.110:3010/', //backend-authentication
  // baseURL: 'https://api2.puntu.-com.br/', //backend-authentication
  baseURL: 'https://api2.puntu.digital/', //backend-authentication
});

instance.interceptors.response.use(
  response => response,
  (error) => {
    let message = 'Ops, aconteceu um erro inesperado. Já avisamos nosso time. Se precisar entre em contato com suporte.';
    if (error.response) {
      message =
        error.response.data || 'Ocorreu um erro ao processar a solicitação. Tente novamente.';
      if (error.response.status === 403 && error.response.data !== 'O usuário não possui permissão para ser um gestor') {
        message = 'Sessão expirada.';
        setTimeout(() => {
          history.push('logout');
          window.location.reload();
        }, 1500)
      }
      if (error.response.status >= 500) {
        message = 'Ocorreu um erro ao processar a solicitação. Tente novamente.';
      }
    }

    if (error.response && error.response.data && error.response.data.message) {
      return Promise.reject(error.response.data.message);
    }

    return Promise.reject(message);
  },
);

export default instance;
